import z from 'zod'
import {
  type EntityId,
  type Preference,
  isUserId,
  isUserPreference,
  isTeamId,
  TEAM_PREFERENCES,
  isCompanyId,
  COMPANY_PREFERENCES,
  EntityIdSchema,
  PreferenceSchema,
} from '@terros/common'
import { PREFERENCE_GROUPS, type PreferenceGroup } from '@front/model'

export const isPreferenceVisible = (targetId: EntityId, preference: Preference): boolean => {
  if (isUserId(targetId)) {
    return isUserPreference(preference)
  }
  if (isTeamId(targetId)) {
    return TEAM_PREFERENCES.includes(preference)
  }
  if (isCompanyId(targetId)) {
    return COMPANY_PREFERENCES.includes(preference)
  }
  return true
}

export const PreferenceItemPropsSchema = z
  .object({
    preference: PreferenceSchema,
    label: z.string(),
    description: z.string(),
    targetId: EntityIdSchema,
  })
  .loose()

export const toPreferenceGroup = (value: string | null): PreferenceGroup | undefined =>
  PREFERENCE_GROUPS.find((group) => group === value)
